import { render, staticRenderFns } from "./YouTubeButtons.vue?vue&type=template&id=2d5030e1&scoped=true"
import script from "./YouTubeButtons.vue?vue&type=script&lang=js"
export * from "./YouTubeButtons.vue?vue&type=script&lang=js"
import style0 from "./YouTubeButtons.vue?vue&type=style&index=0&id=2d5030e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5030e1",
  null
  
)

export default component.exports